export default __webpack_public_path__ + "static/szyszkowski-70bd4d3ba95f49766fee1c8ad96c6364.jpg";